import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ExpandMore,
  moment,
} from "../../Collections/Imports";
import GlobalDateRangePicker from "../../Components/CommonComponents/GlobalDateRangePicker";
import "./style.css";
import GlobalMultiSelect from "../../Components/CommonComponents/GlobalMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { updateChannelFilterData } from "../../Store/ChannelModule/filter";
import { updatePubOptions } from "../../Store/PublisherModule/filter";

import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../Services/ApiCallService";
import {
  publisherModuleApiEndPoints,
  coreAPIEndsPoints,
} from "../../Config/APIsEndpoints";
import { updateLabelOptions } from "../../Store/Global/LabelOptions";
import { updateManagerOptions } from "../../Store/Global/ManagerOptions";
import { updateTypeOptions } from "../../Store/Global/TypeOptions";
import { updateBuyesOptions } from "../../Store/Global/BuyersOptions";
import { click } from "@testing-library/user-event/dist/click";
import CustomButton from "../../Components/CommonComponents/GlobalButton";
import { allPubData } from "../../Store/PublisherModule";
import GlobalDropdown from "../../Components/CommonComponents/GlobalDropdown";

const ChannelFilters = (props) => {
  const {
    setOpen,
    isOpen,
    defaultValues,
    isEditMode,
    defaultChannel,
    ClearFilters,
  } = props;
  const previousFilterData = useSelector(
    (state) => state?.channelFilterSession?.filterData
  );

  const channelListOptions = useSelector(
    (state) => state?.ChannelData?.data?.allChannelList
  );
  const channelLabels = useSelector(
    (state) => state?.channelLabels?.tableData?.channelLabel
  );
  const channelLabelOptions = channelLabels.map(({ name }) => ({
    value: name,
    label: name,
  }));
  const dispatch = useDispatch();

  const AllFilterLength = useSelector(
    (state) => state?.channelFilterSession.filterData
  );

  const pubOptions = useSelector(
    (state) => state.publisherData?.data?.allPublisherList
  );

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      status: "All",
      channelNames: ["All"],
      channelLabels: ["All"],
      publisherNames: ["All"],
    },
    // resolver: yupResolver(validationSchema),
    mode: "all",
  });

  const [selectedDateFilter, setSelectedDateFilter] = useState({
    startDate: new Date("July 01, 2020"),
    endDate: new Date(),
    key: "selection",
  });

  //***********FORM SUBMISSION ********//
  const onFormSubmit = (data) => {
    const filterData = {
      status: data?.status,
      channelNames: data?.channelNames,
      publisherNames: data?.publisherNames,
      channelLabels: data?.channelLabels,
      fromDate: data?.dateRange
        ? moment(selectedDateFilter?.startDate).startOf("day").toDate()
        : moment(data?.dateRange[0]?.startDate).startOf("day").toDate(),
      toDate: data?.dateRange
        ? moment(data?.dateRange[0]?.endDate).endOf("day").toDate()
        : new Date(),
    };

    dispatch(updateChannelFilterData(filterData));
    setOpen(false);
  };

  // useEffect(() => {
  //   if (PublisherList?.isSuccess && PublisherList?.data?.data?.publishers) {
  //     const publisherOptionsSet = new Set();
  //     const publisherOptions = PublisherList?.data?.data?.publishers
  //       .map((pub) => {
  //         const trimmedPublisherName = pub?.publisherName?.trim();
  //         if (
  //           trimmedPublisherName &&
  //           !publisherOptionsSet.has(trimmedPublisherName)
  //         ) {
  //           publisherOptionsSet.add(trimmedPublisherName);
  //           return {
  //             label: trimmedPublisherName,
  //             value: trimmedPublisherName,
  //           };
  //         }
  //         return null;
  //       })
  //       .filter(Boolean);
  //     dispatch(updatePubOptions(publisherOptions));
  //   }
  // }, [PublisherList]);

  // Call setFormValue after initialization
  useEffect(() => {
    if (previousFilterData && Object.keys(previousFilterData)?.length) {
      setFormValue(previousFilterData);
    }
  }, [previousFilterData]);

  // Set Form Value
  const setFormValue = (data) => {
    console.log(data);
    const dateRange = {
      startDate: new Date(data?.fromDate),
      endDate: data?.toDate,
      key: "selection",
    };

    setValue("status", data?.status, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("publisherNames", data?.publisherNames, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("channelNames", data?.channelNames, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("channelLabels", data?.channelLabels, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("dateRange", dateRange, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
  };
  //Push new option All
  const AllOptions = { label: "All", id: 1, value: "All" };

  const [statusOptions, setStatusOptions] = useState([
    { label: "Active", value: "true" },
    { label: "Disabled", value: "false" },
  ]);

  // Pushing the AllOptions object into the statusOptions array
  useEffect(() => {
    setStatusOptions((prevOptions) => [AllOptions, ...prevOptions]);
  }, []);

  return (
    <>
      <Drawer
        anchor={"right"}
        open={isOpen}
        onClose={() => setOpen(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            top: "15px",
            borderRadius: "16px",
            maxWidth: "500px",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            flexWrap="wrap"
            justifyContent={"space-between"}
          >
            <Box marginBottom={"15px"}>
              <Typography component="h6" variant="h6" fontWeight={600}>
                Filters
              </Typography>
            </Box>
            <Box marginBottom={"15px"}>
              <Typography
                component="h7"
                variant="h7"
                fontWeight={200}
                style={{ cursor: "pointer" }}
                onClick={ClearFilters}
              >
                Clear All
              </Typography>
            </Box>
          </Stack>

          <Divider
            sx={{
              mb: "20px",
            }}
          />

          <Box component={"form"} className="accordionGrid">
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "status"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Status{" "}
                  {AllFilterLength?.status && AllFilterLength?.status != "" && (
                    <span className="count-style">
                      <p>1</p>
                    </span>
                  )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalDropdown
                  control={control}
                  size="small"
                  name="status"
                  options={statusOptions}
                  required
                  error={!!errors.status}
                  helperText={errors.status?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "channel"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Channel{" "}
                  {AllFilterLength?.channelNames &&
                    AllFilterLength?.channelNames?.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.channelNames?.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="channelNames"
                  label=""
                  options={channelListOptions}
                  required
                  error={!!errors.channelNames}
                  helperText={errors.channelNames?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "publisher"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Publisher{" "}
                  {AllFilterLength?.publisherNames &&
                    AllFilterLength?.publisherNames?.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.publisherNames?.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="publisherNames"
                  label=""
                  options={pubOptions}
                  required
                  error={!!errors.publisherNames}
                  helperText={errors.publisherNames?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "label"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Label{" "}
                  {AllFilterLength?.channelLabels &&
                    AllFilterLength?.channelLabels.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.channelLabels.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalDropdown control={control} name="label" options={[]} /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="channelLabels"
                  label=""
                  options={channelLabelOptions || []}
                  required
                  error={!!errors.channelLabels}
                  helperText={errors.channelLabels?.message}
                />
              </AccordionDetails>
            </Accordion>
            {/* </Grid> */}

            {/* <Grid item xs={12}> */}
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "created"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Create Date</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <Controller
                  name="dateRange"
                  control={control}
                  render={({ field }) => (
                    <GlobalDateRangePicker
                      defaultRange={{
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      }}
                      {...field}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            direction="row"
            component={Box}
            useFlexGap
            flexWrap="wrap"
            justifyContent={"flex-end"}
            bottom={0}
            marginTop={"1rem"}
          >
            <Box marginBottom={"15px"} marginRight={"5px"}>
              <CustomButton
                color="#3a5396"
                // label="Add Campaign"
                label="Apply Filter"
                onClick={handleSubmit(onFormSubmit)}
              />
            </Box>
            <Box marginBottom={"15px"}>
              <CustomButton
                labelColor="#7a7870"
                variant="outlined"
                color="white"
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Box>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default ChannelFilters;
